import { Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import NavigationBar from "../../../../../utils/wizard/navigation";
import { DatePicker } from "../../../../../utils/form";
import moment from "moment";
import _ from "lodash";
import StepTitle from "../../../../../utils/wizard/steps";

const defaultValues = {
  date: moment().format("YYYY-MM-DD"),
};

const DateForm = ({
  onFinish,
  DateFields = DatePicker,
  formMapper = _.identity,
  ...props
}) => {
  const form = useForm({
    defaultValues: _.assign({}, defaultValues, props.defaultValues),
  });
  const { handleSubmit } = form;

  return (
    <form
      onSubmit={handleSubmit((form) => onFinish(formMapper(form)))}
      autoComplete="off"
    >
      <Stack spacing={3}>
        <StepTitle title="Fecha" />
        <DateFields form={form} name="date" label="Fecha" required {...props} />
      </Stack>
      <NavigationBar {...props} />
    </form>
  );
};

export default DateForm;
